import axios from 'axios';
import { readSession, expireSession } from './session';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true
});

api.interceptors.request.use((config) => {
  const hadSession = Boolean(localStorage.getItem('user'));
  const user = readSession();
  if (hadSession && !user) expireSession();
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data } = error.response || {};
    const message = data?.error || '';
    const sentToken = error.config?.headers?.Authorization;
    const currentUser = readSession();
    if (
      sentToken &&
      (!currentUser || sentToken === `Bearer ${currentUser.token}`) &&
      (status === 401 || (status === 403 && /token.*(inválido|expirado|caducado)/i.test(message)))
    ) {
      expireSession();
    }
    return Promise.reject(error);
  }
);

export default api;
